import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, Link } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { authService } from '../services/api';
import BrandPanel from '../components/BrandPanel';
import Logo from '../components/Logo';
import { Button } from '../components/ui';

function VerifyEmail() {
  const { token } = useParams();
  const { t } = useTranslation();
  const { isAuthenticated, user, updateUser } = useAuthStore();
  const [status, setStatus] = useState('pending'); // pending | success | error

  useEffect(() => {
    let mounted = true;
    authService.verifyEmail(token)
      .then(() => {
        if (!mounted) return;
        setStatus('success');
        if (isAuthenticated && user) updateUser({ is_verified: true });
      })
      .catch(() => mounted && setStatus('error'));
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="min-h-screen flex bg-surface-50">
      <BrandPanel />

      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="max-w-sm w-full text-center">
          <Link to="/" className="mb-8 lg:hidden inline-block">
            <Logo size={36} textColor="text-gray-900" />
          </Link>

          {status === 'pending' && (
            <>
              <div className="w-10 h-10 mx-auto mb-4 border-2 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
              <p className="text-gray-600">{t('Verifying your email...')}</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-5">
                <svg className="w-7 h-7 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold font-display tracking-tight text-gray-900">{t('Email verified!')}</h2>
              <p className="text-sm text-gray-500 mt-2 mb-8">{t('Your email address has been confirmed.')}</p>
              <Button onClick={() => window.location.href = isAuthenticated ? '/dashboard' : '/login'}>
                {isAuthenticated ? t('Go to Dashboard') : t('Go to Login')}
              </Button>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="w-14 h-14 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-5">
                <svg className="w-7 h-7 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold font-display tracking-tight text-gray-900">{t('Verification failed')}</h2>
              <p className="text-sm text-gray-500 mt-2 mb-8">{t('This verification link is invalid or has already been used.')}</p>
              <Link to={isAuthenticated ? '/dashboard' : '/login'} className="text-sm text-primary-600 font-medium hover:underline">
                {isAuthenticated ? t('Go to Dashboard') : t('Go to Login')}
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
